"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CheckboxLabelDescription_1 = __importDefault(require("./CheckboxLabelDescription"));
exports.default = CheckboxLabelDescription_1.default;
